import { ButtonBasic, InputDinamycPlaceholder } from "@lk-gtcom/ecomlab-components";
import './ModalAddTaskExit.scss'

const ModalAddTaskExit = ({
    setIsModal,
    setIsModalClose,
    fetchDeleteTask,
    eventId,
    setIsNew,
    update
}) => {

    return (
        <div className='blackout blackout-modal-2'
            style={{ zIndex: 12 }}
            onClick={(e) => {
                let el = e.target
                if (el.classList.contains('blackout-modal-2')) {
                    setIsModal(false)
                }
            }}>
            <div className='modal-add-task-exit'>
                <h1 className='modal-add-task-exit__title'>Чтобы сохранить задачу, необходимо заполнить "Название" и "Статус"?</h1>
                <div className='modal-add-task-exit__group-btn'>
                    <ButtonBasic
                        grey
                        text='Продолжить редактирование'
                        width='100%'
                        onClick={(e) => {
                            setIsModal(false)
                        }}
                    />

                    <ButtonBasic
                        red
                        text='Выйти'
                        width='100%'
                        onClick={(e) => {
                            fetchDeleteTask(eventId, false)
                            update()
                            setIsNew(false)
                            setIsModal(false)
                            setIsModalClose(false)
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export { ModalAddTaskExit }